import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';

const colorTheme = (outerTheme) =>
  createMuiTheme({
    palette: {
      error: { main: outerTheme.common.Alert.style.textColor },
    },
  });

const useStyles = makeStyles((theme) => {
  return {
    errorWrapper: {
      backgroundColor: theme.common.Alert.Wrapper.style.backgroundColor,
      border: theme.common.Alert.Wrapper.style.border,
      padding: theme.common.Alert.Wrapper.style.padding,
    },
  };
});

const Alert = ({ children, align = 'left' }) => {
  const classes = useStyles();

  return (
    <ThemeProvider
      theme={(outerTheme) => ({ ...outerTheme, ...colorTheme(outerTheme) })}
    >
      <div className={`${classes.errorWrapper} alert`}>
        <Typography align={align} variant="body2" color="error">
          {children}
        </Typography>
      </div>
    </ThemeProvider>
  );
};

export default Alert;
